import React from 'react';
import './CallToAction.css';

const CallToAction = () => {
  const projectedImpact = [
    { metric: 'New Investors', value: '30,000+', description: '0.1% conversion rate' },
    { metric: 'Year 1 AUM', value: '$15M+', description: 'Average $500 investment' },
    { metric: 'Participation Rate', value: '5x', description: 'vs traditional platforms' }
  ];

  return (
    <div className="call-to-action">
      <div className="cta-header">
        <h2 className="cta-title">Transform celebrity influence into investment power</h2>
      </div>

      <div className="cta-benefits">
        <div className="benefit-card">
          <span className="benefit-icon">✅</span>
          <span className="benefit-text">Leverage CAA's 30M+ engaged audience for tokenized investments</span>
        </div>
        <div className="benefit-card">
          <span className="benefit-icon">✅</span>
          <span className="benefit-text">Transform celebrity endorsements into investment opportunities</span>
        </div>
        <div className="benefit-card">
          <span className="benefit-icon">✅</span>
          <span className="benefit-text">First-mover advantage in celebrity-backed tokenization</span>
        </div>
        <div className="benefit-card">
          <span className="benefit-icon">✅</span>
          <span className="benefit-text">Proven engagement = Proven investment interest</span>
        </div>
      </div>

      <div className="projected-impact">
        <h3 className="impact-title">PROJECTED IMPACT</h3>
        <div className="impact-grid">
          {projectedImpact.map((item) => (
            <div key={item.metric} className="impact-card">
              <div className="impact-value">{item.value}</div>
              <div className="impact-metric">{item.metric}</div>
              <div className="impact-description">{item.description}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CallToAction;